/*
Used this article to help with locations + inventory:
https://www.biscuitsbundles.com/blog/how-to-limit-inventory-and-stock-to-each-market-in-shopify-markets
*/

import { emitter } from '../lib/utils';
import Swiper from 'swiper';
import { Thumbs } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default class Product {
  constructor({ el }) {
    this.el = el;

    // carousel els
    this.mainCarouselEl = this.el.querySelector('.main-carousel');
    this.thumbCarouselEl = this.el.querySelector('.thumb-carousel');
    this.currentSlideEl = this.el.querySelector('.current-slide');
    this.prevBtn = this.el.querySelector('.controls .prev');
    this.nextBtn = this.el.querySelector('.controls .next');
    this.clickOverlay = this.el.querySelector('.click-overlay');

    this.init();
  }

  init() {
    if (this.mainCarouselEl) {
      this.thumbCarousel = new Swiper(this.thumbCarouselEl, {
        slidesPerView: 'auto',
        loop: true,
        spaceBetween: 10,
        watchSlidesProgress: true,
        direction: 'vertical',
        modules: [Thumbs],
      });

      this.carousel = new Swiper(this.mainCarouselEl, {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        allowTouchMove: true,
        thumbs: {
          swiper: this.thumbCarousel,
        },
        grabCursor: true,
        modules: [Thumbs],
      });

      this.carousel.on('slideChange', () => {
        this.currentSlideEl.textContent = this.carousel.realIndex + 1;

        // if current slide has a video, set current time to 0
        const currentSlide = this.carousel.slides[this.carousel.realIndex];
        if (currentSlide.querySelector('video')) {
          currentSlide.querySelector('video').currentTime = 0;
        }
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.carousel.slidePrev();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.carousel.slideNext();
        });
      }

      if (this.clickOverlay) {
        this.clickOverlay.addEventListener('click', () => {
          this.carousel.slideNext();
        });
      }

      this.slides = Array.from(this.mainCarouselEl.querySelectorAll('.swiper-slide'));

      emitter.on('product:variant-changed', (newVariantId) => {
        // check if any of the slides have a data-attached-variants attribute that contains the new variant id
        const slideWithNewVariant = this.slides.findIndex((slide) => {
          const idsArray = slide.dataset.attachedVariants?.split(',');

          return idsArray?.includes(newVariantId);
        });

        if (slideWithNewVariant !== -1) {
          this.carousel.slideTo(slideWithNewVariant);
        }
      });
    }
  }
}
